/* eslint-disable import/prefer-default-export */
import { SENTRY_KEY } from 'env';

// THIS CONDITION IS FOR ALWAYS USE THE SENTRY DEV PROJ EVEN IF LOAD PRODUCTION SCHEMA
// USING THIS WE AVOID REPORTING FALSE POSITIVES ON PROD PROJ
export const SENTRY_DNS = __DEV__ ? 'https://cb511b5b4c6b4788b729e9e23b5e967b@o198934.ingest.sentry.io/6489852' : SENTRY_KEY;
